import React, { useEffect, useState } from 'react'
import Modal from '../../components/UI/Modal'
import { getApiErrorMessage, saveDigitalOffer } from '../../api/adminPaymentsApi'

const normalizeOffer = (product, offer) => ({
  code: offer?.code || `P3D-${product?._id || ''}`,
  title: offer?.title || product?.fullName || product?.name || '3D-модель',
  description: offer?.description || '',
  price: offer?.price ?? 0,
  isActive: offer?.isActive !== false,
  requiresLicense: offer?.requiresLicense !== false,
  allowCard: offer?.allowCard !== false,
  allowUserBalance: offer?.allowUserBalance !== false,
  allowOfficeBalance: offer?.allowOfficeBalance !== false,
  userScope: !offer || !Array.isArray(offer.licenseScopes) || offer.licenseScopes.includes('User'),
  officeScope: !offer || !Array.isArray(offer.licenseScopes) || offer.licenseScopes.includes('Office'),
})

export default function DigitalOfferModal({ show, item, onClose, onSaved }) {
  const product = item?.product || null
  const [form, setForm] = useState(() => normalizeOffer(product, item?.offer))
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    setForm(normalizeOffer(product, item?.offer))
    setError('')
  }, [product?._id, item?.offer?._id])

  const set = (key, value) => setForm((prev) => ({ ...prev, [key]: value }))

  const handleSave = async () => {
    if (!product?._id) return
    const price = Number(form.price)
    if (!Number.isFinite(price) || price < 0) {
      setError('Цена должна быть числом от 0 ₽.')
      return
    }
    const scopes = [form.userScope ? 'User' : null, form.officeScope ? 'Office' : null].filter(Boolean)
    if (!scopes.length) {
      setError('Разреши хотя бы одну область лицензии: пользователь или офис.')
      return
    }

    setSaving(true)
    setError('')
    try {
      const offer = await saveDigitalOffer(product._id, {
        code: form.code,
        title: form.title,
        description: form.description,
        price,
        isActive: form.isActive,
        requiresLicense: form.requiresLicense,
        allowCard: form.allowCard,
        allowUserBalance: form.allowUserBalance,
        allowOfficeBalance: form.allowOfficeBalance,
        licenseScopes: scopes,
      })
      onSaved?.(offer)
    } catch (err) {
      setError(getApiErrorMessage(err, 'Не удалось сохранить цифровое предложение'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      show={show}
      handleClose={onClose}
      modalTitle={item?.offer ? 'Настройка цифровой продажи' : 'Подключить цифровую продажу'}
      size="lg"
    >
      <div className="admin-payments__offer-modal">
        <div className="admin-payments__offer-product">
          <div>
            <span>Товар</span>
            <strong>{product?.fullName || product?.name || '—'}</strong>
          </div>
          <div>
            <span>Артикул</span>
            <strong>{product?.article || '—'}</strong>
          </div>
          <div>
            <span>Категория</span>
            <strong>{product?.categoryName || '—'}</strong>
          </div>
        </div>

        <div className="admin-payments__form-grid">
          <label>
            <span>Код предложения</span>
            <input value={form.code} onChange={(e) => set('code', e.target.value.toUpperCase())} />
          </label>
          <label>
            <span>Название</span>
            <input value={form.title} onChange={(e) => set('title', e.target.value)} />
          </label>
          <label>
            <span>Цена цифровой лицензии, ₽</span>
            <input type="number" min="0" step="0.01" value={form.price} onChange={(e) => set('price', e.target.value)} />
          </label>
          <label className="is-wide">
            <span>Описание</span>
            <textarea rows={3} value={form.description} onChange={(e) => set('description', e.target.value)} />
          </label>
        </div>

        <div className="admin-payments__switch-grid">
          <label><input type="checkbox" checked={form.isActive} onChange={(e) => set('isActive', e.target.checked)} /><span>Продажа активна</span></label>
          <label><input type="checkbox" checked={form.requiresLicense} onChange={(e) => set('requiresLicense', e.target.checked)} /><span>Требовать лицензию для 3D</span></label>
          <label><input type="checkbox" checked={form.allowCard} onChange={(e) => set('allowCard', e.target.checked)} /><span>Оплата картой</span></label>
          <label><input type="checkbox" checked={form.allowUserBalance} onChange={(e) => set('allowUserBalance', e.target.checked)} /><span>Личный баланс</span></label>
          <label><input type="checkbox" checked={form.allowOfficeBalance} onChange={(e) => set('allowOfficeBalance', e.target.checked)} /><span>Баланс офиса</span></label>
          <label><input type="checkbox" checked={form.userScope} onChange={(e) => set('userScope', e.target.checked)} /><span>Лицензия USER</span></label>
          <label><input type="checkbox" checked={form.officeScope} onChange={(e) => set('officeScope', e.target.checked)} /><span>Лицензия OFFICE</span></label>
        </div>

        <div className="admin-payments__info-note">
          Если продажа отключена, старый 3D-доступ не ломается сам по себе: правила доступа определяет BACKEND. Цена 0 ₽ выдаёт бесплатную лицензию.
        </div>
        {error ? <div className="admin-payments__error">{error}</div> : null}
        <div className="admin-payments__modal-actions">
          <button type="button" onClick={onClose}>Отмена</button>
          <button type="button" className="admin-payments__primary" disabled={saving} onClick={handleSave}>
            {saving ? 'Сохранение…' : 'Сохранить'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
